import { computed, type ComputedRef, type Ref, ref } from 'vue'

export type UserData = {
    email?: string
    profile?: {
        lastSystemVersionRead?: boolean | null
        [key: string]: unknown
    } | null
    lastSystemVersionRead?: boolean | null
    [key: string]: unknown
}

export type UserState = {
    token: Ref<string | null>
    userId: Ref<number | null>
    userName: Ref<string | null>
    userEmail: Ref<string | null>
    user: Ref<UserData | null>
    permissionsReceived: Ref<boolean>
    permissions: Ref<unknown[]>
    loggedIn: ComputedRef<boolean>
}

export function createUserState(): UserState {
    const token = ref<string | null>(localStorage.getItem('token') || null)
    const userId = ref<number | null>(Number(localStorage.getItem('userId')) || null)
    const userName = ref<string | null>(localStorage.getItem('userName') || null)
    const userEmail = ref<string | null>(localStorage.getItem('userEmail') || null)
    const user = ref<UserData | null>(null)
    const storedPermissionsReceived = localStorage.getItem('receivedPermissions')
    const permissionsReceived = ref<boolean>(
        (storedPermissionsReceived ? JSON.parse(storedPermissionsReceived) : false) as boolean
    )
    const permissions = ref<unknown[]>((JSON.parse(localStorage.getItem('userPermissions') || 'null') || []) as unknown[])

    const loggedIn = computed<boolean>(() => token.value !== null && permissionsReceived.value)

    return {
        token,
        userId,
        userName,
        userEmail,
        user,
        permissionsReceived,
        permissions,
        loggedIn
    }
}
